const videoLocation = document.getElementById('hero-video')

if (videoLocation) {
    function addAutoplay () {
        if (window.innerWidth > 768) {
            videoLocation.setAttribute('autoplay', '')
            videoLocation.play()
        };
    }

    window.onload = addAutoplay()
}
